import QuickActionsVM from './quick-actions-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init(element) {
    let vm = new Vue(QuickActionsVM);
    vm.$mount(element);
  }
};
